import { InstiService } from './../../../insti/insti.service';
import { Component, Inject } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent {
  public config: PerfectScrollbarConfigInterface = {};
  // This is for Notifications

  constructor(private router: Router,protected service: InstiService,  @Inject(DOCUMENT) private document: Document){
    this.setTipoUser(this.checkMenuExibir());


  }
  tipoUser:number;  //1-Funcionário 2-Terceiro 3-Administrador
  exibeLicenca: boolean = false;
  
  getTipoUser(){
    return this.tipoUser;
  }

  setTipoUser(value){
    this.tipoUser = value;
  }

  checkMenuExibir(){
    console.log(this.service.getUser());
    if(this.service.getUser().getData()['tipo'] == 2){//Se o tipo for Administrador
      return this.exibeLicenca = true;
    }
  
    return this.exibeLicenca = false;
  }

  notifications: Object[] = [
    {
      round: 'round-danger',
      icon: 'ti-link',
      title: 'Launch Admin',
      subject: 'Just see the my new admin!',
      time: '9:30 AM'
    },
    {
      round: 'round-success',
      icon: 'ti-calendar',
      title: 'Event today',
      subject: 'Just a reminder that you have event',
      time: '9:10 AM'
    },
    {
      round: 'round-info',
      icon: 'ti-settings',
      title: 'Settings',
      subject: 'You can customize this template as you want',
      time: '9:08 AM'
    },
    {
      round: 'round-primary',
      icon: 'ti-user',
      title: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: 'assets/images/users/1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung a song! See you at',
      time: '9:10 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am a singer!',
      time: '9:08 AM'
    },
    {
      useravatar: 'assets/images/users/4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  logout(){
    localStorage.removeItem('empSelecionadas');
    this.router.navigate([this.service.getLoginUrl(true)]);
  }

  gotoMeusDados(){
    this.router.navigate(['gestao-condominio/meus-dados']);
  }
  gotoConfig(){
    this.router.navigate(['gestao-condominio/configuracoes']);
  }

  renderConfig(){
    return this.service.getUser().getData()['tipo'] == 2 ? true : false;
  }

  gotoEmpresa(){
    this.router.navigate(['gestao-condominio/empresa-filial']);
  }
  


  gotoLicenca(): void {
      this.document.location.href = 'https://stackoverflow.com';
    
  }

  renderLicenca(){
    return this.service.getUser().getData()['tipo'] == 2 ? true : false;
  }






  

}
